import { useState, useEffect } from 'react'
import SearchField from 'react-search-field';
import { Link } from 'react-router-dom'
import AddProfile from './AddProfile'
import EditUserProfile from './EditUserProfile'

const Profiles = ({language, setBreadcrumbObject}) => {
    const [searchTypeHeader, setSearchTypeHeader] = useState(language.value === "DA" ? "Profiler" : "Profiles")
    const [viewType, setViewType] = useState('profiles')
    const [profiles, setProfiles] = useState()
    const [users, setUsers] = useState()
    const [editor, setEditor] = useState()
    const [list, setList] = useState()
    const [showAddProfile, setShowAddProfile] = useState(false)
    const [searchTypeDescription, setSearchtypeDescription] = useState(language.value === "DA" ? "Her vises listen over dine profiler. Vælg fra listen for at ændre rettigheder og hvilke brugere der er tilknyttet den enkelte profil." : "The list of your profiles is displayed here. Select from the list to change rights and which users are associated with each profile.")
    
    useEffect(() => {
          
        const getData = async () => {
            const data = await fetchData()
            setProfiles(data.profiles)
            setUsers(data.editors)
            setList(data.profiles)
            setBreadcrumbObject({type: '', name:language.value === "DA" ? "Profiler " : "Profiles ", link: '', linkText: ''})            
        }
      
          getData()
    },[language])

    const fetchData = async () => {

        var graphql = JSON.stringify({
            query: `query {
                        profiles {
                            id
                            profileName
                            isReadonly
                        }
                        editors{
                            id
                            editorName
                            editorEmail
                            editorPwd
                            profileId
                        }
                    }`,
            variables: {}
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        return data
    }
      
    const handleSearch = (keyword) => {
        if(viewType === 'profiles'){
            setList(profiles.filter((profile) => profile.profileName.toLowerCase().includes(keyword.toLowerCase())))
        }
        if(viewType === 'users'){
            setList(users.filter((user) => user.editorName.toLowerCase().includes(keyword.toLowerCase()) || user.editorEmail.toLowerCase().includes(keyword.toLowerCase())))
        }
    }

    const handleShowViewType = async e => {
        let type = (viewType === 'profiles' ? 'users' : 'profiles')
        if(type === 'profiles'){
            setBreadcrumbObject({type: '', name:language.value === "DA" ? "Bruger profiler " : "User profiles ", link: '', linkText: ''})
            setSearchTypeHeader(language.value === "DA" ? "Profiler" : "Profiles")
            setSearchtypeDescription(language.value === "DA" ? "Her vises listen over dine profiler. Vælg fra listen for at ændre rettigheder og hvilke brugere der er tilknyttet den enkelte profil." : "The list of your profiles is displayed here. Select from the list to change rights and which users are associated with each profile.")
            setList(profiles)
            setEditor()
        }
        if(type === 'users'){
            setBreadcrumbObject({type: '', name:language.value === "DA" ? "Brugere " : "Users ", link: '', linkText: ''})
            setSearchTypeHeader(language.value === "DA" ? "Brugere" : "Users")
            setSearchtypeDescription(language.value === "DA" ? "Her vises listen over brugere. Vælg fra listen for at ændre rettigheder for den enkelte bruger." : "The list of users is displayed here. Select from the list to change the rights of the individual user.")
            setList(users)
        }
        setViewType(type)
    }

    const handleAddProfileShow = async e => {
        e.preventDefault();
        setShowAddProfile(showAddProfile ? false : true)
    }

    
    let content;

    if (list) {
        content = (
            <div id="cc_profile_editcontainer">
                <div id="cc_profile_item">
                    <div className="cc_explaintxt">
                        <span>{searchTypeHeader}</span>
                        <i>{searchTypeDescription}</i>
                    </div>
                    <div id="cc_profile_list_filter" className="cc_list_filter">
                        <div className="filter-block">
                            <span>
                                {language.value === 'DA' ? `Søg efter ${searchTypeHeader}` : `Search for ${searchTypeHeader}`}
                            </span>
                            
                            <SearchField classNames="searchInput" onChange={handleSearch} placeholder={language.value === 'DA' ? `Søger i ${searchTypeHeader}` : `Search in ${searchTypeHeader}`} />
                        </div>
                        <div className="filter-block">
                            <span>&nbsp;</span>
                            <div className="btn-group">
                                <button onClick={handleShowViewType} disabled={viewType === 'profiles'} className={`cc-btn ${viewType === 'profiles' ? "active" : ""}`}>{language.value === 'DA' ? 'Profiler' : 'Profiles'}</button>
                                <button onClick={handleShowViewType} disabled={viewType === 'users'} className={`cc-btn ${viewType === 'users' ? "active" : ""}`}>{language.value === 'DA' ? 'Brugere' : 'Users'}</button>
                            </div>
                        </div>
                        <div className="filter-block">
                            <span>&nbsp;</span>
                            <div className="btn-group">
                                {viewType === 'profiles' && <button onClick={handleAddProfileShow} className="cc-btn blue-gradient">{language.value === 'DA' ? 'Tilføj ny profil' : 'Add new profile'}</button> }
                            </div>
                        </div>
                    </div>          
                    <div id="cc_profile_item_list" className="cc_item_list">
                    {
                        list.map((item) => (
                                ((viewType === 'profiles') ?
                                    <label className="list-item"><Link to={`/control/profiles/${item.id}`}><span>{item.profileName}</span></Link></label>
                                :
                                    <label className="list-item" to={`#`} onClick={()=> setEditor(editor != item ? item : null)}><span>{item.editorName}</span><small>{item.editorEmail}</small></label>
                                )
                        ))
                    }
                    </div>
                </div>
                <div id="cc_info_panel" className="scrollable">
                    {(editor) && <EditUserProfile editor={editor} language={language} profiles={profiles} showProfileLink={true} />}
                </div>
                <AddProfile language={language} isVisible={showAddProfile} setIsVisible={setShowAddProfile} profiles={profiles} setProfiles={setProfiles}/>
            </div>
        )
    }


    return (
        <>
          {content}
        </>
    )
}

export default Profiles
